// ▶ "Média de venda por cliente" da aba Histórico da ficha do produto.
//
// Exemplo dela, 2o teste real, 03/09: "se ele positivou 10 clientes e esse
// produto ele vendeu pra 1 cliente, sua média de venda por cliente é 10%".
// "Positivou" usa a MESMA regra de `metas/metasDados.ts` (positivacao =
// clientes distintos entre as vendas do período) -- uma regra só, e não uma
// segunda copia que diverge com o tempo.
export function mediaDeVendaPorCliente(
  clientesQueCompraramEsteProduto: number,
  clientesPositivados: number,
): number | null {
  // 0/0 nao e "vendeu pra ninguem" -- e "o periodo nao tem dado nenhum ainda".
  // Afirmar 0% mentiria uma medida que nao existe.
  if (clientesPositivados === 0) return null
  return Math.round((clientesQueCompraramEsteProduto / clientesPositivados) * 100)
}
